import BaseService from './BaseService';
import { Observable } from "rxjs";
import { CBlocker } from '@/components/Blocker/CBlocker';
export default class GroupService {
    constructor() {
        this.path = 'groups';
    }
    getAll(filter, order, page, length) {
        let content = Object();
        if (filter) {
            content.filter = filter;
        }
        if (order) {
            content.order = order;
        }
        if (page) {
            content.page = page;
        }
        if (length) {
            content.length = length;
        }
        return BaseService.get(this.path, content);
    }
    get(id) {
        return BaseService.get(this.path + '/' + id);
    }
    add(group) {
        CBlocker.showLoading();
        let content = group;
        delete (group.devices);
        return new Observable((observer) => {
            BaseService.post(this.path, content, undefined, false).subscribe((success) => {
                observer.next(success);
                CBlocker.showSuccess('Grupo añadido');
            }, (error) => {
                observer.error(error);
                CBlocker.showError(error.message);
            });
        });
    }
    update(group) {
        CBlocker.showLoading();
        let content = group;
        delete (group.devices);
        return new Observable((observer) => {
            BaseService.put(this.path + '/' + group.id, content, undefined, false).subscribe((success) => {
                observer.next(success);
                CBlocker.showSuccess('¡Actualizado!');
            }, (error) => {
                observer.error(error);
                CBlocker.showError(error.message);
            });
        });
    }
    delete(group) {
        CBlocker.showLoading();
        return new Observable((observer) => {
            BaseService.delete(this.path + '/' + group.id, undefined, false).subscribe((success) => {
                observer.next(success);
                CBlocker.showSuccess('Grupo eliminado');
            }, (error) => {
                observer.error(error);
                CBlocker.showError(error.message);
            });
        });
    }
    getEnums(name) {
        if (GroupService.enums.length == 0) {
            let content = {};
            if (name)
                content.name = name;
            return BaseService.get(this.path + '/enums', content);
        }
        else {
            return new Observable((observer) => {
                observer.next(GroupService.enums);
            });
        }
    }
}
GroupService.enums = new Array();
